import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["indent", "width"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N800 } from '@atlaskit/theme/colors';
import { indentBase } from './styled';
var commonStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  minHeight: 40,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  padding: "var(--ds-space-100, 10px)".concat(" ", indentBase, " ", "var(--ds-space-100, 10px)", " var(--indent, ").concat(indentBase, ")"),
  position: 'relative',
  alignItems: 'center',
  color: "var(--ds-text, ".concat(N800, ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  hyphens: 'auto',
  wordBreak: 'break-word'
});
/**
 * __Common cell__
 */
var CommonCell = function CommonCell(_ref) {
  var indent = _ref.indent,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    role: "gridcell"
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    style: {
      '--indent': indent,
      width: width
    },
    css: commonStyles
  }));
};
export default CommonCell;